export const AUTO_SAVE_TIME_DEFAULT = 600
export const AUTO_SAVE_WORD_COUNT_DEFAULT = 50
export const ASR_DURATION_DEFAULT = 8

/** Upper bound on holding a meeting recording open across a network outage
 *  before it is ended anyway. Sized to outlast Meet/Zoom's own auto-reconnect
 *  window. Bounds both the recording's reconnect hold and the native end
 *  detector's offline grace, which run on separate clocks. */
export const NETWORK_RECONNECT_HOLD_MAX_MS = 30 * 60 * 1000

export type MeetingMode = 'autopilot' | 'notify' | 'silent'

export const DEFAULT_MEETING_MODE: MeetingMode = 'autopilot'
